module.exports = __webpack_public_path__ + "img/lumilive_4.ec4769aa.png";